import { NavLink } from 'react-router';
import { CurtinLogo } from './CurtinLogo';
import { AWMSLogo } from './AWMSLogo';

export const Logos = () => {
  return (
    <div className="flex flex-row gap-x-5 justify-between">
      <div>
        <CurtinLogo />
      </div>
      <NavLink aria-label="AWMS Home" to="/">
        <AWMSLogo />
      </NavLink>
    </div>
  );
};
